import * as Yup from 'yup';

// Scan Manual Search Schema Validation
export const validationSearchReferenceSchema = Yup.object().shape({
    searchReference: Yup.string().required('Identifiant machine requis'),
});